import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import strings from "../helpers/Localization";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import PageMetaHelmet from "../aGlobalDesign/PageMetaHelmet/PageMetaHelmet";

class NotFound extends React.Component {

    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.pageNotFound);
    }

    render() {
        return <div className="defaultPageContent">
            <PageMetaHelmet title={strings.pageNotFound} icon={"/icons/favicon.ico"} />
            <Paper className="defaultPagePaper" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <Typography className="noselect" style={{ flex: 1, marginBottom: "20px" }} variant="h1" noWrap >
                        {strings.notFound}
                    </Typography>
                    <Typography className="noselect" style={{ flex: 1, marginBottom: "20px" }} variant="h6" noWrap >
                        {strings.pageNotFound.toUpperCase()}
                    </Typography>
                </div>
            </Paper>
        </div>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(NotFound);
